// src/main.tsx

import * as React from "react";

import {
  createRoot,
} from "react-dom/client";

import {
  BrowserRouter,
} from "react-router-dom";

import App from "./App";

import "./index.css";

/* -------------------------------------------------------------------------- */
/* Bootstrap                                                                  */
/* -------------------------------------------------------------------------- */

const rootElement =
  document.getElementById(
    "root",
  );

if (
  !rootElement
) {
  throw new Error(
    "Root element not found",
  );
}

createRoot(
  rootElement,
).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);